import { motion } from "framer-motion";

const items = [
  {
    title: "Network Security Deployment",
    category: "Cybersecurity",
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=400&h=200&fit=crop",
    icon: (
      <svg viewBox="0 0 24 24" className="w-7 h-7 fill-cyber-blue">
        <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z" />
      </svg>
    ),
    link: "/case-studies/enterprise-network-security",
  },
  {
    title: "CCTV Surveillance Systems",
    category: "CCTV",
    image: "https://images.unsplash.com/photo-1558002038-1055907df827?w=400&h=200&fit=crop",
    icon: (
      <svg viewBox="0 0 24 24" className="w-7 h-7 fill-tech-green">
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
      </svg>
    ),
    link: "/case-studies/smart-cctv-surveillance",
  },
  {
    title: "ISP Infrastructure Design",
    category: "Networking",
    image: "https://images.unsplash.com/photo-1563770660941-10a45f3bdb5e?w=400&h=200&fit=crop",
    icon: (
      <svg viewBox="0 0 24 24" className="w-7 h-7 fill-cyber-blue">
        <path d="M3.33 16.5H9l1 2.5h4l1-2.5h5.67L17 12l2.67-4.5H15l-1-2.5h-4L9 7.5H3.33L6 12l-2.67 4.5z" />
      </svg>
    ),
    link: "/case-studies/isp-network-infrastructure",
  },
  {
    title: "Cybersecurity SOC Monitoring",
    category: "Cybersecurity",
    image: "https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?w=400&h=200&fit=crop",
    icon: (
      <svg viewBox="0 0 24 24" className="w-7 h-7 fill-tech-green">
        <path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.07.62-.07.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58z" />
      </svg>
    ),
    link: "/case-studies/cybersecurity-monitoring",
  },
  {
    title: "Web Development Solutions",
    category: "Web Dev",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=200&fit=crop",
    icon: (
      <svg viewBox="0 0 24 24" className="w-7 h-7 fill-cyber-blue">
        <path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z" />
      </svg>
    ),
    link: "/case-studies/business-website-suite",
  },
];

export default function MovingShowcase() {
  return (
    <section className="relative w-full py-20 overflow-hidden bg-[#0a0a0a]">
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="text-3xl md:text-4xl font-bold text-center mb-12 px-6"
      >
        Our{" "}
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyber-blue to-tech-green">
          Engineering in Motion
        </span>
      </motion.h2>

      <div className="group/marquee w-full">
        <div className="marquee-track flex gap-6 w-max">
          {[...items, ...items].map((item, i) => (
            <a
              key={i}
              href={item.link}
              className="group glass rounded-2xl overflow-hidden min-w-[260px] sm:min-w-[280px] md:min-w-[320px] flex flex-col glass-hover hover:!scale-[1.03] transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-32 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-transparent" />
              </div>
              <div className="p-5 flex flex-col gap-3">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center shrink-0">
                    {item.icon}
                  </div>
                  <span className="glass text-[11px] font-semibold px-2.5 py-1 rounded-full text-tech-green">
                    {item.category}
                  </span>
                </div>
                <h3 className="text-white font-bold text-base md:text-lg leading-snug">
                  {item.title}
                </h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
